export const VERIFIED_BY_ML = "Verified By ML";

export const DEFAULT_PAGE_SIZE = 100;
